<template>
    <div class="vx-row">
        <div class="vx-col w-full xl:w-1/1 mb-base text-center">
            <template v-if="showNavigation">
                <vs-button 
                    color="dark" 
                    type="line" 
                    icon-pack="feather" 
                    icon="icon-arrow-left" 
                    @click="$emit('prev-period')"
                    :disabled="isLoading"
                    style="display:inline;"
                />
                <span class="ml-5 mr-5">{{ displayRange }}</span>
                <vs-button 
                    color="dark" 
                    type="line" 
                    icon-pack="feather" 
                    icon="icon-arrow-right" 
                    @click="$emit('next-period')"
                    :disabled="isLoading"
                    style="display:inline;"
                />
            </template>
            <template v-if="showTodayButton">
                <vs-button 
                    color="primary" 
                    type="line" 
                    class="ml-3"
                    @click="$emit('go-today')"
                    :disabled="isLoading || isToday"
                >
                    오늘
                </vs-button>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DateRangeNavigation',
    props: {
        displayRange: {
            type: String,
            default: ''
        },
        showNavigation: {
            type: Boolean,
            default: true
        },
        showTodayButton: {
            type: Boolean,
            default: true
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        isToday: {
            type: Boolean,
            default: false
        }
    },
    emits: ['prev-period', 'next-period', 'go-today']
};
</script>

<style scoped>
.ml-3 {
    margin-left: 0.75rem;
}

.ml-5 {
    margin-left: 1.25rem;
}

.mr-5 {
    margin-right: 1.25rem;
}
</style>